itsoftApp.createModule("toggleTabs", function () {
    var module = this;

    const Tabs = function (tabs) {
        this.tabs = tabs;
        this.tabsInitialized = false;
        this.isContainingTabs = this.tabs.hasAttribute("data-tabs-caption"); /* Содержит ли вкладка дочерние табы */
        this.togglers = this.tabs.querySelector(".js-tabs-list.js-toggle"); /* находим на странице возможный тогглер */
        this.noHash = this.tabs.hasAttribute("data-no-hash"); // если стоит этот атрибут, табы будут перкеключаться без изменения хэша
        this.isTogglerProgress = ""; // this.toggler.classList.contains("js-toggle-progress");
        this.togglerProgress = ""; // tabs.querySelector(".js-progress");
        this.tabsItems = []; // все кнопки для переключения вкладок
        this.currentActiveTabs = []; // все активные кнопки для переключения вкладок
        this.currentActiveContents = []; // все активные секции активной вкладки
        this.clickedTab = ""; // кнопка, на которую кликнули в данный момент
        this.clickedTabName = ""; // название кнопки, на которую кликнули
        this.dataActiveSectionClass;
        this.dataActiveSectionSelector;
        this.sectionElement;
        this.toggleFlag = 0;
        this.dataButtons = ""; // Название кнопок табов 
        this.dataSection = ""; // Название секции табов
        this.currentTab = "";
        this.tabSelector = "";
        this.tabsContents = "";

        /* в зависимости от условий */
        this.dataSliderName = ""; /* название слайдера, который требуется листать при переключении табов */
        this.dataLevel = ""; /* вложенная секция с табами */
        this.dataLevelValue = ""; /* название уровня вложенной секции с табами */
        this.dataTabsValue = ""; /* название уровня списка кнопок во вложенной секции с табами** */

        this.init();
    };

    Tabs.prototype.init = function () {
        if (this.tabs.hasAttribute("data-slider-name")) {
            this.sliderName = this.tabs.getAttribute("data-slider-name");
        }

        if (this.isContainingTabs) {
            this.dataLevel = this.tabs.querySelector("[data-level]");
            this.dataTabsValue = this.tabs.getAttribute("data-tabs-caption");
            this.dataButtons = this.tabs.querySelector("[data-tabs-buttons='" + this.dataTabsValue + "']");
            this.dataSection = this.tabs.querySelector("[data-tabs-section='" + this.dataTabsValue + "']");
        }

        if (this.dataLevel) {
            this.dataLevelValue = this.dataLevel.getAttribute("data-level");
        }

        if (!this.isContainingTabs) {
            this.dataButtons = this.tabs.querySelector(".js-tabs-list");
            this.dataSection = this.tabs.querySelector(".js-tabs-content");
        }

        if (this.dataLevel && this.dataLevelValue === this.dataTabsValue) {
            /* если название указано, находим активные секции только внутри блока с названием табов */
            this.currentActiveContents = this.dataSection.querySelectorAll(".js-tab-content--active[data-level='" + this.dataTabsValue + "']");
        } else {
            /* иначе находим все */
            this.currentActiveContents = this.dataSection.querySelectorAll(".js-tab-content--active");
        }

        this.tabsItems = this.dataButtons.querySelectorAll(".js-tab-name");

        this.currentActiveTabs = this.dataButtons.querySelectorAll(".js-tab-name--active");

        for (let i = 0; i < this.tabsItems.length; i++) {
            this.addTabClickListener(this.tabsItems[i]);
        }

        if (!this.tabsInitialized) {
            this.tabsInitialized = true;

            if (location.hash && !this.noHash) {
                this.goToHash(location.hash);
            }

            if (this.isTogglerProgress && this.togglerProgress) {
                let element;
                let contentElements;
                let contentSelector;
                const tabsExample = this;
                const togglerProgress = this.togglerProgress;
                const startAnimation = itsoftApp.modules.animation.callback;
                const options = {
                    draw: function (progress) {
                        togglerProgress.style.transform = "scaleX(" + (progress * 100) + "%)";
                    },
                    timing: function(timeFraction) {
                      return timeFraction;
                    },
                    duration: 5000,
                    cb: function () {
                        if (tabsExample.tabsItems[0].classList.contains("js-tab-name--active")) {
                            element = tabsExample.tabsItems[1];
                            contentSelector = "[data-content-url='" + element.getAttribute("data-tab-name") + "']";
                            contentElements = tabsExample.dataSection.querySelectorAll(contentSelector);
                            tabsExample.goToTab(element, contentElements);
                        } else {
                            element = tabsExample.tabsItems[0];
                            contentSelector = "[data-content-url='" + element.getAttribute("data-tab-name") + "']";
                            contentElements = tabsExample.dataSection.querySelectorAll(contentSelector);
                            tabsExample.goToTab(element, contentElements);
                        }
                
                        startAnimation(options);
                    }
                }

                startAnimation(options);
            }

            /* Этот метод позволяет перейти к любой вкладке по хэшу из другого модуля */
            module.callback.goToHash = this.goToHash;
        }
    };

    Tabs.prototype.goToHash = function (newHash) {
        let element;
        let contentElements;
        let contentSelector;

        if (newHash) {
            newHash = newHash.replace(/^#/,"");
            let selector = "[data-tab-name='" + newHash + "']";
            contentSelector = "[data-content-url='" + newHash + "']";
            element = this.dataButtons.querySelector(selector);
            contentElements = this.dataSection.querySelectorAll(contentSelector);
        } else {
            element = this.tabsItems[0];
            contentSelector = "[data-content-url='" + element.getAttribute("data-tab-name") + "']";
            contentElements = this.dataSection.querySelectorAll(contentSelector);
        }

        // DEBUG && console.log("contentElementsHash", contentElements);

        if (element) {
            this.goToTab(element, contentElements, newHash);
        }
    };

    Tabs.prototype.goToTab = function (tab, contents, newHash) {
        /* Логика переключения к определенному табу */
        this.toggleFlag = 0;

        if (this.tabs.classList.contains("js-init-settings")) {
            this.tabs.classList.remove("js-init-settings");
        }

        this.clickedTab = tab;

        if (!this.clickedTab.classList.contains("js-tab-name--active")) {
            if (this.toggler && !this.toggleFlag && newHash != this.tabsItems[0].getAttribute("data-tab-name")) {
                this.toggler.classList.toggle("js-toggle--active");
                this.toggleFlag = 1;
            }
        }

        Array.prototype.forEach.call(this.currentActiveTabs, function (currentActiveTab) {
            currentActiveTab.classList.remove("js-tab-name--active");
        });

        Array.prototype.forEach.call(this.currentActiveContents, function (currentActiveContent) {
            currentActiveContent.classList.remove("js-tab-content--active");
        });

        if (this.dataActiveSectionClass) {
            this.sectionElement.classList.remove(this.dataActiveSectionClass);
        }

        if (this.dataSliderName) {
            let slideIndex = this.clickedTab.getAttribute("data-slide-to");
            
            if (itsoftApp.modules.slidersLibrary.sliders[this.sliderName]) {
                itsoftApp.modules.slidersLibrary.sliders[this.sliderName].slideTo(+slideIndex);
            }
        }

        this.clickedTabName = this.clickedTab.getAttribute("data-tab-name");

        if (!this.noHash) {
            location.hash = this.clickedTabName;
        }

        this.currentActiveTabs = this.dataButtons.querySelectorAll("[data-tab-name='" + this.clickedTabName + "']");
        this.dataActiveSectionSelector = tab.getAttribute("data-section-selector");

        if (this.dataActiveSectionSelector) {
            this.sectionElement = this.dataSection.querySelector(this.dataActiveSectionSelector);
        }

        this.dataActiveSectionClass = tab.getAttribute("data-section-class");

        if (this.dataActiveSectionClass) {
            this.sectionElement.classList.add(this.dataActiveSectionClass);
        }

        this.currentActiveContents = contents;

        Array.prototype.forEach.call(this.currentActiveTabs, function (currentActiveTab) {
            currentActiveTab.classList.add("js-tab-name--active");
        });

        Array.prototype.forEach.call(this.currentActiveContents, function (currentActiveContent) {
            let customScroll = currentActiveContent.querySelector(".custom-scroll");
            if (customScroll && !customScroll.classList.contains("js-triggered")) {
                customScroll.classList.add("js-triggered");
                itsoftApp.modules.customScrollbar.callback(customScroll);
            }

            currentActiveContent.classList.add("js-tab-content--active");
        });

        Array.prototype.forEach.call(itsoftApp.modules.scrollEffects.scrollEffectElements, function (scrollEffectElement) {
            scrollEffectElement._check();
        });
    };

    Tabs.prototype.onTabClick = function (currentTab) {
        this.currentTab = currentTab;

        if (this.currentTab.hasAttribute("data-tab-name")) {
            this.tabSelector = this.currentTab.getAttribute("data-tab-name");

            if (!this.noHash) {
                location.hash = this.tabSelector;
            }
        }
        
        this.tabsContents = this.dataSection.querySelectorAll("[data-content-url='" + this.tabSelector + "']");
        // DEBUG && console.log("dataSection", dataSection);
        // DEBUG && console.log("contentElements", tabsContents);
        // После обработки клика передаём элемент, на который произошёл клик, и элемент (вкладка), который должен быть показан универсальной функции goToTab
        if (!this.currentTab.closest(".js-disabled-tabs")) {
            this.goToTab(this.currentTab, this.tabsContents);
        }
    };

    Tabs.prototype.addTabClickListener = function (tab) {
        /* Добавляем обработчик события клика */
        tab.addEventListener("click", function (evt) {
            evt.preventDefault();
            if (!evt.currentTarget.classList.contains("js-tab-name--active")) {
                this.onTabClick(tab);
            } else if (this.tabs.classList.contains("js-init-settings")) {
                this.tabs.classList.remove("js-init-settings");
            }
        }.bind(this));
    };

    module.callback = {};
    module.callback.init = Tabs;
});